// @flow strict

/* eslint-disable import/prefer-default-export */

export const modalFadeInDuration = 150;
export const modalFadeOutDuration = 75;
export const modalBorderRadius = 4;
export const modalBoxShadow = '0 11px 15px -7px rgba(0, 0, 0, 0.2), 0 24px 38px 3px rgba(0, 0, 0, 0.14), 0 9px 46px 8px rgba(0, 0, 0, 0.12)';
